var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 19,
    viewBox: "0 0 29 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 19,
    fill: "url(#pattern0_81_52)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_81_52",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_81_52",
    transform: "matrix(0.00727969 0 0 0.0111111 0.172414 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_81_52",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAByUlEQVR4nO3ZS0oDQRSF4WzCgU/cjqDiNnyvxUHoc9rEgUPnUXei4ipinKkoBS2oiFZ3qiFU/R8UNBnUPZfqZ2UwAAAAAAAAAAAAAAAAAAAAAAAgFdsbko4l3dq+l/QcRnMcfjsaDofryQqWlqGqqlXblvRq+/2f8Wb7qqqqzZTNVblnsL1nexYx8bch6cn2booGnXsG26fNyrSa/MeqnszZ4GnWGZoVnGfyr0U6nVXOPUNd12tdLpO/Lp/RaLTSpsG6hAy2L1JN/mWct2nSuWdoXl1inqptV/M1nCGRDW5knyHctHtYxc8ih5FNnmSfwfZNXwVsTyKbvMk+g6THHgvcxzSpEjKkfMr+MmaRZ9Ms+ww9F5guQJPThcgg6aHHAncxTaqEDEU8iBYhQ9ji67HAfmSTR9lnCPuofbyo236J/VgYlpLB9ih1AUmKafBTERnCBnezj5qqwNT2cpsmq1Iy2N5KdOm8Sdpp02BxGZrv/bk2vMN/a10aLC5D2KzuePlM67renqfB4jKMx+Ml22fhiRm5epdt74f/KSpDeC0JW3ySrsPXTfOZOmuOJ7YPYl+fuiIDAAAAAAAAAAAAAAAAAAAAAGBQog+ECmtT51tT3QAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/Ellipsis.9c0471df705ecaa7932c8427c0a7f490.svg";
export { ForwardRef as ReactComponent };